import { useCallback } from 'react';

import { useAuth } from './useAuth';

type AuthFetch = (
  input: RequestInfo | URL,
  init?: RequestInit
) => Promise<Response>;

/**
 * tokenを付与する fetch ラッパー
 *
 * vercel ai sdk のuseChatはfetchを使用するためアクセストークンを付与する必要がある。
 * 補足：sagaのAPIリクエストではAxiosのinterceptor （useInterceptToken）を使用している。
 */
export const useAuthFetch = (): AuthFetch => {
  const { getAccessTokenSilently, loginWithRedirect } = useAuth();

  return useCallback(
    async (input, init = {}) => {
      // 必ず最新トークンを取得
      const token = await getAccessTokenSilently();

      // Authorizationのみ上書きしてfetchを実行
      const res = await fetch(input, {
        ...init,
        headers: {
          ...(init.headers ?? {}),
          Authorization: `Bearer ${token}`,
        },
      });
      // 認証エラー時（401 や 403 ）ログイン画面へリダイレクト
      if (res.status === 401 || res.status === 403) {
        loginWithRedirect();
      }

      return res;
    },
    [getAccessTokenSilently, loginWithRedirect]
  );
};
